import { Directive, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import * as _ from 'lodash';
import {ButtonComponent} from "@ispm/shared/components/button/button.component";

@Directive({
  selector: '[buttonClickPermission]'
})
export class ButtonClickPermissionDirective implements OnInit{

  @Input() requiredPermission: string = null;
  private userPermissions: string [];

  constructor(
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef
  ) {
  }

  ngOnInit(): void {
    this.userPermissions = JSON.parse(localStorage.getItem('user')).permissions;
      const _injector = this.viewContainerRef.parentInjector;
      const _parent: ButtonComponent = _injector.get<ButtonComponent>(ButtonComponent);
      _parent.disabled = (!this.userHasPermission());
  }

  userHasPermission(): boolean {
    return (_.includes(this.userPermissions, this.requiredPermission) || !this.requiredPermission);
  }
}
